<div class="col-lg-12 col-md-12 col-12">
    <div class="bk-title--default text-center mb--70">
         <h6 class="heading heading-h6 theme-color"></h6>
         <div class="bkseparator--30"></div>
         <h3 class="heading heading-h3"><br>Conexión Akashico<sup>®</sup> Facilitador</h3>
     </div>
     <div class="row">
        
         <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/4771455577.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Ana Bethania Navarro de Luna</li>
                     <li>thannya_navarro@hotmail.com</li>
                     <li>TEL. 4771455577</li>
                     <li>Ciudad del Carmen, Campeche</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
          <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/2223638138.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Angélica Espíndola Rodríguez</li>
                     <li>angie_espn@hotmail.com</li>
                     <li>TEL. 2223638138 </li>
                     <li>Puebla, Puebla</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->  
         
           <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9994457016.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Mercedes Guadalupe Cab </li>
                     <li>azul_turquesa24@hotmail.com</li>
                     <li>TEL. 9994457016 </li>
                     <li>Merida, Yucatán</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
                        
         
         
         
         
         

       
     </div>
 </div>
